import { BarChart, XAxis, YAxis, Bar, LabelList, ResponsiveContainer } from "recharts";
import { DailyRVUStat } from "../../../types/DailyRVUStat";
import { useMemo } from "react";

type Props = Pick<
  DailyRVUStat,
  "totalRVUs" | "totalStudies" | "userId" | "totalCYRVUs" | "unmappedStudies"
>;

const DailyRVURowGraph: React.FC<Props> = ({
  totalRVUs,
  totalStudies,
  userId,
  totalCYRVUs,
  unmappedStudies,
}) => {
  const fontStyle = {
    fontSize: "10px",
    fontWeight: 700,
    lineHeight: "18px",
    fill: "#000",
    fontFamily: "Inter",
  };
  const total = useMemo(
    () => totalRVUs + totalCYRVUs + totalStudies + unmappedStudies,
    [totalCYRVUs, totalRVUs, totalStudies, unmappedStudies],
  );
  const cornerRadius = 28;
  const cornerRadiusByTotal = total === 0 ? cornerRadius : 0;

  return (
    <ResponsiveContainer width="100%" height={18}>
      <BarChart
        margin={{
          right: 24,
        }}
        height={16}
        data={[{ totalRVUs, totalStudies, totalCYRVUs, unmappedStudies, userId }]}
        layout="vertical"
      >
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="userId" hide />
        <Bar
          minPointSize={16}
          dataKey="totalCYRVUs"
          radius={[cornerRadius, cornerRadiusByTotal, cornerRadiusByTotal, cornerRadius]}
          stackId="a"
          fill="rgba(247, 227, 118, 1)"
          barSize={16}
        >
          <LabelList
            style={fontStyle}
            dataKey="totalCYRVUs"
            position="center"
            formatter={(props: number) => {
              return props === 0 ? "" : Math.round(props).toString();
            }}
          />
        </Bar>
        <Bar
          minPointSize={16}
          radius={cornerRadiusByTotal}
          dataKey="totalRVUs"
          stackId="a"
          fill="#FF9760"
          barSize={16}
        >
          <LabelList
            style={fontStyle}
            dataKey="totalRVUs"
            position="center"
            formatter={(props: number) => {
              return props === 0 ? "0" : Math.round(props).toString();
            }}
          />
        </Bar>
        <Bar
          minPointSize={16}
          radius={cornerRadiusByTotal}
          dataKey="totalStudies"
          stackId="a"
          fill="rgba(145, 182, 254, 1)"
          barSize={16}
        >
          <LabelList style={fontStyle} dataKey="totalStudies" position="center" />
        </Bar>
        <Bar
          minPointSize={16}
          radius={[cornerRadiusByTotal, cornerRadius, cornerRadius, cornerRadiusByTotal]}
          dataKey="unmappedStudies"
          stackId="a"
          fill="#FEC0A8"
          barSize={18}
        >
          <LabelList style={fontStyle} dataKey="unmappedStudies" position="center" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DailyRVURowGraph;
